import apiPenghasilan from '@/api/member/penghasilan';

const defaultState = () => ({
	saldo: null,
	saldoDepositUserArr: null,
	depositUserMutasi: null,
	saldoMutasi: null,
	saldoWithdraw: null,
	mutasiPagination: '',
	withdrawPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: '',
	configWdValue: {
		minimum: 50000,
		cut: 6500,
		adm: 0,
	},
});

const state = defaultState();

const getters = {};

const mutations = {
	setConfigWdValue(state, data) {
		state.configWdValue = data
	},
	setDepositUserMutasi(state, data) {
		state.depositUserMutasi = data.data
	},
	setSaldoDepositUserArr(state, data) {
		state.saldoDepositUserArr = data.data
	},
	setSaldo(state, data) {
		state.saldo = data.data
	},
	setSaldoMutasi(state, data) {
		state.saldoMutasi = data.data
	},
	setSaldoWithdraw(state, data) {
		state.saldoWithdraw = data.data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearPesanan(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getConfigWd({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getConfigWd(params).then(({ data: { data } }) => {
				console.log("dataaaa", data)
				commit('setConfigWdValue', data);
				resolve(true);
			}).catch(() => {
				// commit('setSaldoWithdraw', { data: [] });
			}).then(() => {

			});
		});
	},
	getWithdrawDepositUser({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getWithdrawDepositUser(params).then(({ data: { data } }) => {
				commit('setSaldoWithdraw', { data: data.results });
				state.withdrawPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setSaldoWithdraw', { data: [] });
			}).then(() => {

			});
		});
	},
	previewWithdrawDepositUser({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPenghasilan.previewWithdrawDepositUser(params).then((data) => {
				// dispatch('success', data.data)
				resolve(data.data.data);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	requestWithdrawDepositUser({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPenghasilan.requestWithdrawDepositUser(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	getSaldoSummaryDepositUser({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoSummaryDepositUser(params).then(({ data: { data } }) => {
				commit('setSaldoDepositUserArr', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setSaldoDepositUserArr', { data: [] });
			}).then(() => {

			});
		});
	},
	getDepositUserMutasi({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getDepositUserMutasi(params).then(({ data: { data } }) => {
				commit('setDepositUserMutasi', { data: data.results });
				state.mutasiPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setDepositUserMutasi', { data: [] });
			}).then(() => {

			});
		});
	},
	getSaldoSummary({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoSummary(params).then(({ data: { data } }) => {
				commit('setSaldo', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setSaldo', { data: [] });
			}).then(() => {

			});
		});
	},
	getSaldoMutasi({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoMutasi(params).then(({ data: { data } }) => {
				commit('setSaldoMutasi', { data: data.results });
				state.mutasiPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setSaldoMutasi', { data: [] });
			}).then(() => {

			});
		});
	},

	getSaldoWithdraw({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoWithdraw(params).then(({ data: { data } }) => {
				commit('setSaldoWithdraw', { data: data.results });
				state.withdrawPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setSaldoWithdraw', { data: [] });
			}).then(() => {

			});
		});
	},

	requestWithdraw({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPenghasilan.requestWithdraw(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},

	success({ commit }, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};